import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ConsumerCibilDownloadModalUI from './ConsumerCibilDownloadModalUI'

class ConsumerCibilDownloadModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      submitted: false,
      reportingRangeCode: '',
      reportingRangeError: null,
    }
  }

  render() {
    let reportingRangeList = [
      { key: 'P1', value: 'Incremental Reporting Cycle 1 (1st–9th)' },
      { key: 'P2', value: 'Incremental Reporting Cycle 2 (10th–16th)' },
      { key: 'P3', value: 'Incremental Reporting Cycle 3 (17th–23rd)' },
      { key: 'P4', value: 'Full File Reporting (24th–EOM)' },
    ]

    return (
      <ConsumerCibilDownloadModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        downloadMode={this.props.downloadMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.onCancelClick}
        //
        reportingRangeCode={this.state.reportingRangeCode}
        onReportingRangeChange={(event) => { this.setState({ reportingRangeCode: event.target.value }) }}
        reportingRangeError={this.state.reportingRangeError}
        setReportingRangeError={(error) => { this.setState({ reportingRangeError: error }) }}
        reportingRangeList={reportingRangeList}
      />
    )
  }

  componentDidMount() {
    Modal.setAppElement('body')
  }

  onCancelClick = () => {
    this.setState({
      successMsg: null,
      errorList: null,
      submitted: false,
      reportingRangeCode: '',
      reportingRangeError: null,
    })
    this.props.onCancelClick()
  }

  onSubmit = () => {
    if (this.state.submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    RestApiUtils.get(this.props.context,
      `/api/su/accounts/loans/dpd/consumer/excel/fileDownloadSignedUrl?rangeCode=${this.state.reportingRangeCode}&year=${this.props.match.params.year || ''}&month=${this.props.match.params.month || ''}`,
      this.onSubmitCallback, null, null
    )
  }

  onSubmitCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      setTimeout(() => {
        this.onCancelClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList })
  }
}

export default withRouter(ConsumerCibilDownloadModalSF)
